import React from 'react'

interface PageLayoutProps {
  children: React.ReactNode
  maxWidth?: 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full'
}

export const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  maxWidth = '3xl' 
}) => {
  const getMaxWidthClass = () => {
    switch (maxWidth) {
      case 'lg':
        return 'max-w-[1024px]'
      case 'xl':
        return 'max-w-[1280px]'
      case '2xl':
        return 'max-w-[1400px]'
      case '3xl':
        return 'max-w-[1500px]'
      case '4xl':
        return 'max-w-[1700px]'
      case '5xl':
        return 'max-w-[1900px]'
      case 'full':
        return 'max-w-full'
      default:
        return 'max-w-[1500px]'
    }
  }

  return (
    <div className={`${getMaxWidthClass()} mx-auto p-6`}>
      {children}
    </div>
  )
}